import React, { useState } from 'react';
import linkedInData from '../data/linkedin.json';

const LinkedIn = () => {
  const { description, linkedinPosts } = linkedInData;
  const [modalImage, setModalImage] = useState(null);

  const openImage = (src) => setModalImage(src);
  const closeModal = () => setModalImage(null);

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2 style={{ marginBottom: '0.25rem' }}>LinkedIn Campaign Posts</h2>
      <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1.5rem', maxWidth: '900px' }}>
        {description}
      </p>

      {linkedinPosts.map((post) => (
        <div
          key={post.id}
          style={{
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '1.5rem',
            marginBottom: '2rem',
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          }}
        >
          {post.type === 'carousel' ? (
            <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                marginBottom: '1rem',
              }}
            >
            <img
              src="/Linkedin/linkedin-avatar.png"
              alt="User avatar"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
            <div>
              <strong style={{ display: 'block', fontSize: '0.95rem' }}>Rubix</strong>
              <span style={{ fontSize: '0.75rem', color: '#777' }}>Solving for the Modern Workplace · 1h · 🌐</span>
            </div>
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
            {post.title}
          </h3>
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              scrollSnapType: 'x mandatory',
              WebkitOverflowScrolling: 'touch',
              gap: '1rem',
              paddingBottom: '1rem',
            }}
          >
          {post.slides.map((slide, idx) => (
            <div
              key={idx}
              style={{
                minWidth: '320px',
                maxWidth: '320px',
                flexShrink: 0,
                scrollSnapAlign: 'start',
                borderRadius: '8px',
                border: '1px solid #ded',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                textAlign: 'center',
              }}
            >
              <img
                src={slide.image}
                alt={slide.caption}
                onClick={() => openImage(slide.image)}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px',
                  cursor: 'pointer',
                }}
              />
              <div style={{ padding: '0.75rem', fontSize: '0.9rem', color: '#333' }}>
                {slide.caption}
              </div>
            </div>
          ))}
        </div>

        {post.ctaButton && (
          <a
            href={post.ctaButton.url}
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#ea7400',
              color: '#fff',
              padding: '0.5rem 1rem',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: 'bold',
              marginTop: '0.5rem',
            }}
          >
            {post.ctaButton.text}
          </a>
        )}
        <p style={{ fontSize: '0.95rem', color: '#333', marginBottom: '1rem', lineHeight: '1.4' }}>
          {post.text}
        </p>
        <p style={{ fontSize: '0.85rem', color: '#888', marginTop: '0.75rem' }}>
          {post.hashtags.join(' ')}
        </p>
        </>
          ) : (
            <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                marginBottom: '1rem',
              }}
            >
            <img
              src="/Linkedin/linkedin-avatar.png"
              alt="User avatar"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
            <div>
              <strong style={{ display: 'block', fontSize: '0.95rem' }}>Rubix</strong>
              <span style={{ fontSize: '0.75rem', color: '#777' }}>Solving for the Modern Workplace · 1h · 🌐</span>
            </div>
          </div>
              <img
                src={post.image}
                alt={post.headline}
                style={{
                  width: '100%',
                  minWidth: '320px',
                  maxWidth: '640px',
                  borderRadius: '6px',
                  marginBottom: '1rem',
                  cursor: 'pointer',
                }}
                onClick={() => openImage(post.image)}
              />
              <h3 style={{ marginBottom: '0.5rem' }}>{post.headline}</h3>
              <p style={{ marginBottom: '1rem', fontSize: '0.95rem', color: '#444' }}>
                {post.text}
              </p>
              {post.ctaButton && (
                <a
                  href={post.ctaButton.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-block',
                    backgroundColor: '#ea7400',
                    color: '#fff',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                  }}
                >
                  {post.ctaButton.text}
                </a>
              )}
              <p style={{ fontSize: '0.85rem', color: '#888', marginTop: '1rem' }}>
                {post.hashtags.join(' ')}
              </p>
            </>
          )}
        </div>
      ))}

      {/* Modal for viewing full image */}
      {modalImage && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '90vh',
              background: '#000',
              padding: '1rem',
              borderRadius: '8px',
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                fontSize: '2rem',
                background: 'transparent',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <img
              src={modalImage}
              alt="Preview"
              style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '6px' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LinkedIn;